import { formatCnae } from 'utils/masks/formatCnae'

import { AssinaturaConjunta, FormDataType, LegalRepresentativeFieldType } from './form.model'

export const firstStepFields: FormDataType[] = [
  { id: 'nomeCompleto', label: 'Nome completo' },
  { id: 'email', label: 'E-mail', disabled: true },
  { id: 'telefone', label: 'Telefone', mask: 'phone' },
  { id: 'cep', label: 'CEP', mask: 'cep' },
  { id: 'cnpj', label: 'CNPJ', mask: 'cnpj', disabled: true },
  { id: 'razaoSocial', label: 'Razão Social' },
  { id: 'nomeFantasia', label: 'Nome Fantasia', maxLength: 100 },
  // 'cnae' não existe em TextFieldProps['mask'] (@cash-me/react-components) — usa format local (ver src/utils/masks/README.md)
  { id: 'cnae', label: 'CNAE', format: formatCnae, maxLength: 9 }
]

export const legalRepresentativeFields: LegalRepresentativeFieldType[] = [
  { id: 'nome', label: 'Nome do representante Legal', maxLength: 100 },
  { id: 'cpf', label: 'CPF', mask: 'cpf' },
  { id: 'dataNascimento', label: 'Data de nascimento', mask: 'date' },
  { id: 'email', label: 'E-mail' }
]

export const assinaturaConjuntaOptions: { value: AssinaturaConjunta; title: string }[] = [
  { value: 'SIM', title: 'Sim' },
  { value: 'NAO', title: 'Não' }
]
